import { MRT_ColumnDef, MRT_TableOptions } from 'material-react-table'
import { AuthUser } from '@/types/users'
import ZerapixTable from '@/components/zerapix-table/ZerapixTable'
import useZerapixTable from '../zerapix-table/useZerapixTable'

type UsersTableProps = {
  users: AuthUser[]
  columns?: MRT_ColumnDef<AuthUser>[]
  isLoading?: boolean
  renderTableActions?: MRT_TableOptions<AuthUser>['renderTopToolbarCustomActions']
} & Omit<MRT_TableOptions<AuthUser>, 'data' | 'columns'>

const defaultColumns: MRT_ColumnDef<AuthUser>[] = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Email',
    accessorKey: 'email',
  },
]

export default function BaseUsersTable({
  users,
  columns = defaultColumns,
  enableRowSelection = false,
  enableMultiRowSelection = false,
  isLoading = false,
  renderTableActions,
  renderRowActionMenuItems,
  ...props
}: UsersTableProps) {
  const table = useZerapixTable<AuthUser>({
    title: 'Users',
    columns,
    data: users,
    renderTableActions,
    renderRowActionMenuItems,
    enableColumnResizing: true,
    enableMultiRowSelection,
    enableRowSelection,
    enableRowActions: !!renderRowActionMenuItems,
    enableSorting: true,
    getRowId: (row, index) =>
      row.id ?? row.stytch_member?.member_id ?? String(index),
    state: {
      showSkeletons: isLoading,
    },
    localization: {
      noRecordsToDisplay: 'No users have been added to this team.',
    },
    ...props,
  })

  return <ZerapixTable<AuthUser> table={table} />
}
